import React from "react";

// Per-logo height tweaks to optically balance different aspect ratios
const LOGOS = [
  {
    name: "Billboard",
    src: "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/2rvr4mzy_Billboard_logo_PNG_%2810%29.png",
    className: "h-9 md:h-10",
  },
  {
    name: "Rolling Stone",
    src: "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/u9xo6eoq_Rolling-Stone-Logo.jpg",
    className: "h-16 md:h-20",
  },
  {
    name: "TIME",
    src: "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/uuqipd47_time-logo-transparent.png",
    className: "h-10 md:h-11",
  },
  {
    name: "BBC World Service",
    src: "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/4zchmlz1_BBC_World_Service_2022_%28Boxed%29.svg",
    className: "h-12 md:h-14",
  },
  {
    name: "HBO",
    src: "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/pxbzuwtm_hbo-logo-png_seeklogo-65764.png",
    className: "h-11 md:h-12",
  },
  {
    name: "Netflix",
    src: "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/mdo35r63_Netflix_2015_logo.svg.png",
    className: "h-8 md:h-9",
  },
];

export default function FeaturedLogos() {
  return (
    <section className="py-20 md:py-24 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
        <p className="text-sm md:text-base italic font-semibold text-gray-700 tracking-wide mb-12">
          Artists Featured On
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-8 md:gap-x-10 lg:gap-x-12">
          {LOGOS.map((logo) => (
            <div
              key={logo.name}
              className="flex items-center justify-center h-20 md:h-24"
            >
              <img
                src={logo.src}
                alt={logo.name}
                title={logo.name}
                className={`${logo.className} w-auto object-contain opacity-90 hover:opacity-100 transition-opacity`}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
